var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountSummaryLightgray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 2.09668H13.7143M23.1429 7.23954H13.7143M23.1429 12.3824H13.7143M23.1429 22.6681H13.7143M23.1429 17.5253H13.7143M0.857178 2.95382V9.81097C0.857178 10.2843 1.24093 10.6681 1.71432 10.6681H8.57146C9.04485 10.6681 9.42861 10.2843 9.42861 9.81097V2.95382C9.42861 2.48044 9.04485 2.09668 8.57146 2.09668H1.71432C1.24093 2.09668 0.857178 2.48044 0.857178 2.95382ZM0.857178 14.9538V21.811C0.857178 22.2843 1.24093 22.6681 1.71432 22.6681H8.57146C9.04485 22.6681 9.42861 22.2843 9.42861 21.811V14.9538C9.42861 14.4804 9.04485 14.0967 8.57146 14.0967H1.71432C1.24093 14.0967 0.857178 14.4804 0.857178 14.9538Z",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSummaryLightgray);
export default __webpack_public_path__ + "static/media/Account-summary-lightgray.0fda9351.svg";
export { ForwardRef as ReactComponent };